import { Component, OnInit, Input, ChangeDetectorRef } from "@angular/core";
import { ProjectsCampaignRowComponent } from "./projects-campaign-row/projects-campaign-row.component";
import { Campaign } from "../../../@core/data/campaign";
import { CampaignProjectService } from "../../../@core/api/campaign-project.service";
import { NbWindowService, NbWindowState } from "@nebular/theme";
import { LenguageService } from "../../../@core/utils/lenguage.service";
import { Router } from "@angular/router";

@Component({
  selector: "ngx-projects-campaigns-table",
  templateUrl: "./projects-campaigns-table.component.html",
  styleUrls: ["./projects-campaigns-table.component.scss"],
})
export class ProjectCampaignsTableComponent implements OnInit {
  filters: any;
  @Input() type: string;
  @Input() assigned: boolean = false;
  campaigns: Campaign[];
  lastPage: boolean;
  loading: boolean;
  pageNumberShow: number = 1;
  pagination = {
    perPage: 100,
    pageNumber: 0,
  };
  order = {
    field: "timestamp",
    direction: "desc",
  };
  range: any;
  selectedRowId: string = "";
  addFilter: boolean = false;
  dateRange: {
    dateStart: number;
    dateEnd: number;
  };

  constructor(
    private windowService: NbWindowService,
    private router: Router,
    private campaignService: CampaignProjectService,
    public language: LenguageService
  ) {}

  async ngOnInit() {
    this.getCampaigns();
  }

  nextPage() {
    if (!this.lastPage && !this.loading) {
      this.pagination.pageNumber++;
      this.getCampaigns();
      this.pageNumberShow++;
    }
  }

  prevPage() {
    if (this.pagination.pageNumber > 0 && !this.loading) {
      this.pagination.pageNumber--;
      this.getCampaigns();
      this.pageNumberShow--;
    }
  }

  selectRow(data) {
    console.log(data);
    if (data.select) {
      this.selectedRowId = data.id;
    } else {
      this.selectedRowId = "";
    }
    /* 
        let leads = this.leads;
        this.leads = [];
        this.leads = leads; */
  }

  async getCampaigns() {
    this.loading = true;
    this.campaigns = <Campaign[]>(
      await this.campaignService.getCampaigns(
        this.pagination,
        this.filters,
        this.order
      )
    );
    this.loading = false;

    if (this.campaigns.length < this.pagination.perPage) {
      this.lastPage = true;
    } else {
      this.lastPage = false;
    }
  }

  async createCampaign() {
    this.loading = true;
    this.loading = false;
    this.router.navigate(["home", "projects-campaign"]);
  }

  rangeChanged() {
    let dateEnd = new Date(this.range.end).getTime() + 24 * 60 * 60 * 1000;
    let dateStart = (new Date(this.range.start).getTime() * 1000) / 1000;
    this.filters.dateRange = { dateStart, dateEnd };
  }

  async removeFilters() {
    this.dateRange = undefined;
    this.filters = undefined;
    this.addFilter = false;
    await this.getCampaigns();
  }
}
